import { Link } from 'react-router-dom';
import { SalaryCard } from './SalaryCard';

export function HeroSection() {
  return (
    <section
      className="grid grid-cols-1 lg:grid-cols-[55%_45%] min-h-[640px]"
      style={{ borderBottom: 'var(--border-medium)' }}
    >
      {/* Left — Content */}
      <div
        className="px-16 py-20 flex flex-col justify-center"
        style={{ borderRight: 'var(--border-medium)' }}
      >
        <div className="font-mono text-xs uppercase tracking-widest text-gray-500 mb-6">
          ✨ Effortless Payroll for Small Teams
        </div>

        <h1 className="font-display text-[4.5rem] leading-[1.1] font-semibold text-deep-ink tracking-tight mb-6">
          Payroll that{' '}
          <span className="highlight-underline">pays itself</span>.
        </h1>

        <p className="font-body text-xl text-gray-600 max-w-[520px] mb-10 leading-relaxed">
          Say goodbye to spreadsheets. Paradigm automates your salary
          calculations and NIB contributions so you can focus on growing your
          business.
        </p>

        <Link
          to="/register"
          className="inline-block w-fit px-10 py-5 bg-indigo-600 text-white rounded-2xl font-bold hover:scale-[1.02] transition-transform duration-200"
        >
          See Your Savings →
        </Link>
      </div>

      {/* Right — Visual */}
      <div className="bg-slate-800 flex items-center justify-center p-12">
        <SalaryCard />
      </div>
    </section>
  );
}
